import { AppBackground, Text } from '@ui/components'
import React, { useEffect } from 'react'  
import { useDispatch } from 'react-redux'
import { useAppSelector } from '@front/store'
import { Container } from './style'
import { getVetChatUserCredentialsApi } from '@front/apis'
import styled from '@emotion/native'
import { HeaderWithBackAena } from '@/components/headerwithback'

const VetContainer = styled.View(({ theme }) => ({
  width: '100%',
  height: '100%',
}))

const VetChat: React.FC = () => {
  const petGUID = useAppSelector((state) => state.user.selectedPet)

useEffect(() => {
    const initializaVetChat = async () => {
      console.debug('INITIALIZING VETCHAT')
      console.debug('petGUID', petGUID)
      const response = await getVetChatUserCredentialsApi({
        petPassPetGUID: petGUID || '',
        loginProviderType: "AENA",
      })
      console.log('RESPONSE', response)

      const w = window as any

      if (w.meetingdoctors) {
        w.meetingdoctors.initialize({
          apiKey: response.data.meetingKey,
          jwt: response.data.jwt,
          displayMode: 'contained',
          language: 'es',
          defaultOpen: false,
          containerId: 'meetingdoctors-container',
        })
      }
      //TODO: HANDLE CLOSE MEETING DOCTORS
    }
    if (petGUID) initializaVetChat()
  }, [petGUID])

  const meettingDoctorsProfessionalsListWeb = petGUID && <VetContainer id="meetingdoctors-container" />

  return (
    <AppBackground isSafe>
        <HeaderWithBackAena title={' '} navigateTo='/aena/home' />
        <Container>{meettingDoctorsProfessionalsListWeb}</Container>
    </AppBackground>
  )
}

export default VetChat
